import { Injectable } from "@angular/core";
import Ajv from "ajv";
import addFormats from "ajv-formats";

@Injectable({ providedIn: 'root' })
export class FormularValidatorAjvProviderService {
    private _ajv = new Ajv();

    constructor() { addFormats(this._ajv) }

    public addSchema(schema: any | any[]) {
        this._ajv.addSchema(schema);
    }

    public getSchema(schema: string) {
        return this._ajv.getSchema(schema);
    }
}